var _path, _g, _path2, _g2, _path3, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerBg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 333,
    viewBox: "0 0 1440 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4720_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -647,
    y: 0,
    width: 807,
    height: 328
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 328H-647V0H160V328Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4720_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-279.774 -476.57L-7.74799 -260.036C85.1895 -190.789 140.643 -80.4503 140.643 35.3628C140.643 154.854 83.3925 261.176 -5.08411 328.479H-450.131C-537.424 262.085 -594.358 157.729 -595.859 40.1822C-601.736 -16.2976 -581.271 -128.56 -468.461 -222.094L-410.66 -270.013L-314.784 -154.432L-372.585 -106.513C-446.685 -45.0871 -446.833 15.4089 -446.347 24.9208L-445.691 27.711V35.3839C-445.691 155.615 -347.87 253.44 -227.618 253.44C-107.366 253.44 -9.5238 155.636 -9.5238 35.3839C-9.5238 -34.5182 -41.8279 -98.4807 -98.1485 -140.101L-373.325 -359.087L-373.155 -359.298L-590.066 -519.5H-480.807H-334.107L-279.774 -476.57Z",
    fill: "#0D00DF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4720_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -180,
    y: 4,
    width: 1620,
    height: 329
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 4H-180V332.5H1440V4Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4720_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.594 3.99965C618.594 3.99965 579.99 293.311 823.539 430.917C823.539 430.917 935.715 505.871 1043.98 542.502C1108.59 564.359 1165.35 605.915 1202.52 663.114C1232.01 708.496 1254.57 769.182 1251.23 847.244H1438.35C1438.35 847.244 1456.17 607.31 1283.91 455.605C1283.91 455.605 1162.14 350.742 951.254 276.147C951.254 276.147 808.697 233.322 808.697 3.97852H618.594V3.99965Z",
    fill: "#0D00DF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4720_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -180,
    y: 4,
    width: 1620,
    height: 329
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 4H-180V332.5H1440V4Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4720_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1219.94 4H1440V216.666C1440 216.666 1219.94 226.791 1219.94 4Z",
    fill: "#3CD982"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBg1);
export default __webpack_public_path__ + "static/media/banner-bg1.2043a65c2a4fce6739929765201a0c9b.svg";
export { ForwardRef as ReactComponent };